import { render, staticRenderFns } from "./commitPage.vue?vue&type=template&id=d33b8c9c&scoped=true&"
import script from "./commitPage.vue?vue&type=script&lang=js&"
export * from "./commitPage.vue?vue&type=script&lang=js&"
import style0 from "./commitPage.vue?vue&type=style&index=0&id=d33b8c9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b8c9c",
  null
  
)

export default component.exports